export const INLINE_CREATE_AGENT_CONTEXT_KEY = 'jiraAgentCreateContext';
export const INLINE_CREATE_AGENT_FLOW_KEY = 'build_and_chat';
export const INLINE_CREATE_AGENT_MINION_ALIAS = 'build-agent';
